/**
 * @generated SignedSource<<00fa5bd33efe218e2d9dcf6f7f0f5ae5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type superSplashHomeV2Query$data = {
  readonly liveWidget: {
    readonly style: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"superSplashLargeHomeV2LiveWidget" | "superSplashLiveHomeV2LiveWidget">;
  } | null | undefined;
  readonly " $fragmentType": "superSplashHomeV2Query";
};
export type superSplashHomeV2Query$key = {
  readonly " $data"?: superSplashHomeV2Query$data;
  readonly " $fragmentSpreads": FragmentRefs<"superSplashHomeV2Query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "edition"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "superSplashHomeV2Query",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "edition",
              "variableName": "edition"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        },
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": {
            "direction": "DESC",
            "field": "UPDATED_DATE"
          }
        }
      ],
      "concreteType": "LiveWidget",
      "kind": "LinkedField",
      "name": "liveWidget",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "style",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "superSplashLargeHomeV2LiveWidget"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "superSplashLiveHomeV2LiveWidget"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "d05cbeb51597d8adc38b2d1363bff0dd";

export default node;
